import { useMediaQuery } from "react-responsive";

export const useMedia1280 = () => {
  const mediaMobile = useMediaQuery({ query: "(max-width:1280px)" });

  return mediaMobile;
};

export const useMedia1024 = () => {
  const mediaMobile = useMediaQuery({ query: "(max-width:1023px)" });

  return mediaMobile;
};

export const useMedia767 = () => {
  const mediaMobile = useMediaQuery({ query: "(max-width:767px)" });

  return mediaMobile;
};

export const useMediaMd = () => {
  const mediaMd = useMediaQuery({ query: "(min-width:768px)" });

  return mediaMd;
};
